import { handleAdminQuantityDefinitionDeleted } from "./admin";
import {handleUserQuantityDefinitionDeleted} from "./user";


export function handleQuantityDefintionDeleted(state, patch) {

    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionDeleted(state, payload);
    }

    return handleUserQuantityDefinitionDeleted(state, payload);
}